import { render, staticRenderFns } from "./CentroCustoList.vue?vue&type=template&id=0cba05c2&scoped=true"
import script from "./CentroCustoList.vue?vue&type=script&lang=js"
export * from "./CentroCustoList.vue?vue&type=script&lang=js"
import style0 from "./CentroCustoList.vue?vue&type=style&index=0&id=0cba05c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cba05c2",
  null
  
)

export default component.exports